import { Fragment, VFC, useEffect, useState } from 'react';
import { Pagination, PaginationItem, Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import api from '../../config/api';
import {
  H2,
  StyledPageContainer,
  StyledPageContent,
  StyledPageWrapper,
} from '../../components/styles';
import { VotesList } from '../../components/VotesList/VotesList';
import { IVoteBoxProps } from '../../components/VotesList/types';
import { Hero } from '../../components/Hero/Hero';
import { CustomCircular } from 'components/Progress/CustomCircular';

export const List: VFC = () => {
  const [results, setResults] = useState<IVoteBoxProps[] | null>(null);
  const [paginationPageCount, setPaginationPageCount] = useState<number>(1);
  const [paginationPage, setPaginationPage] = useState<number>(1);

  useEffect(() => {
    api
      .get(
        `voting-records?sort=datetime:desc&pagination[pageSize]=100&pagination[page]=${paginationPage}`
      )
      .then((response) => {
        setPaginationPageCount(response.data.meta.pagination.pageCount);
        const data = response.data.data;
        const formattedData = data.map((dataResult: any) => {
          const resultFormatted: IVoteBoxProps = {
            subject: dataResult.attributes.subject,
            date: dataResult.attributes.datetime,
            result: dataResult.attributes.result,
            meetingCode: dataResult.attributes.code,
            id: dataResult.id,
          };

          return resultFormatted;
        });

        setResults(formattedData);
      });
  }, [paginationPage]);

  const handlePaginationChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPaginationPage(value);
    window.scrollTo(0, 0);
  };

  const renderPagination = () => {
    return (
      <Box marginTop={'16px'}>
        <Pagination
          sx={{ display: 'flex', justifyContent: 'center' }}
          count={paginationPageCount}
          page={paginationPage}
          onChange={handlePaginationChange}
          size={window.innerWidth < 410 ? 'small' : 'medium'}
          renderItem={(item) => (
            <PaginationItem
              components={{
                previous: ArrowBackIcon,
                next: ArrowForwardIcon,
              }}
              {...item}
            />
          )}
        />
      </Box>
    );
  };

  return (
    <Fragment>
      <StyledPageWrapper>
        <Hero>
          <StyledPageContainer>
            <H2>Všechny záznamy</H2>
            <p>
              Na této stránce najdete přehled všech výsledků hlasování. Záznamy
              jsou řazeny chronologicky od nejnovějších po nejstarší.
            </p>
          </StyledPageContainer>
        </Hero>
        <StyledPageContainer>
          <StyledPageContent>
            {results === null && <CustomCircular />}
            {results !== null && (
              <>
                {renderPagination()}
                <VotesList votes={results} />
                {renderPagination()}
              </>
            )}
          </StyledPageContent>
        </StyledPageContainer>
      </StyledPageWrapper>
    </Fragment>
  );
};
